module.exports = __webpack_public_path__ + "assets/img/f9ab-eg.svg";